var exports = {
  "kL": "x234b8571--38189f--container",
  "Im": "x234b8571--38189f--comment",
  "NW": "x234b8571--38189f--type",
  "x6": "x234b8571--38189f--button",
};

module.exports = exports;
